import React from 'react'
import heroimg from '../Images/zilbill.webp'

const Hero = () => {
  return (
    <div>
      <div className="w-full">
      <img src={heroimg} alt="Hero" className="w-full h-auto" />
    </div>
    </div>
  )
}

export default Hero
